import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { insights } from '../../../data/insights';
import InsightCard from '../insights/InsightCard';
import useReducedMotion from '../../../hooks/useReducedMotion';

const LatestInsights = () => {
    const prefersReducedMotion = useReducedMotion();

    // Get latest 3 insights (assuming sorted by date descending in data file)
    const latestInsights = insights.slice(0, 3);

    return (
        <section className="py-20 bg-neutral-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                        className="text-3xl md:text-4xl font-bold text-primary-900 mb-4"
                    >
                        Latest Marketing Insights
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        className="text-xl text-neutral-600 max-w-2xl mx-auto"
                    >
                        Strategies and trends to help your business grow
                    </motion.p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
                    {latestInsights.map((insight, index) => (
                        <InsightCard
                            key={insight.id}
                            {...insight}
                            index={index}
                        />
                    ))}
                </div>

                <div className="text-center">
                    <Link
                        to="/insights"
                        className="inline-flex items-center justify-center px-8 py-3 
                       bg-white border-2 border-primary-900 text-primary-900 
                       font-semibold rounded-lg hover:bg-primary-50 
                       transition-colors duration-200"
                    >
                        View All Insights
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default LatestInsights;
